import BaseObject from '../../../../base/base_object';
import Model from './web_view_manager_model';
import {SYSTEM_EVENTS} from '../../../../events/events';
import Event from '../../../../utils/event';
import DOM from '../../../../utils/dom';
import {WEB_VIEW_TYPES, WEB_VIEW_IDS, WEB_VIEW_INFO} from './web_view_manager_consts';
import {KEY_NAME} from '../../native/native_const';
import ServiceFactory from '../../../service_factory';
import Device from "../../../../utils/device/device";
import {Check} from "@sparkware/app-utils";

const PX_DEFAULT = 1;

class WebViewManager extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'WebViewManager';

    _model = null;
    _HybridService = null;
    _displayHybridTimeout = null;
    _ndpToPx = PX_DEFAULT;


    init(params) {

        super.init();

        this._model = Model.create(params);

        this._model.initWebView(WEB_VIEW_TYPES.MASTER, WEB_VIEW_IDS.MASTER_ID,this);

        this._subscribe();
    }

    initFeatures(hybridSrv) {
        this._HybridService = hybridSrv;
        let webView = this._model.getWebViewById(WEB_VIEW_TYPES.MASTER);
        webView.setCbFunctions(this._HybridService);
        this.setHybridDisplayTimeOut();
        this.getDpToPx();
        return this;
    }

    getDpToPx() {
        this._HybridService.getDpToPx().then(data => {
            this._ndpToPx = this._model.getDpToPx(data, PX_DEFAULT);
        })
    }

    _getLogger() {
        return ServiceFactory.create().structuredLoggingService().getLogger();
    }

    /**
     * disable the Feature Game
     */
    setFeatureGameDisable() {
        this._model.setFeatureGameDisable();

        Event.off(SYSTEM_EVENTS.WEB_VIEW_NAVIGATE_GAME, this.openGame, this);

        let logger = this._getLogger();
        logger && logger.setEventType('hybrid_psp_redirect_disable').info();

        Event.off(SYSTEM_EVENTS.WEB_VIEW_NAVIGATE_DEPOSIT_WIDGET, this.openDepositWidget, this);


        Event.off(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, this._onOauthStateChange, this);
        Event.off(SYSTEM_EVENTS.DEEPLINK_RECEIVED, this._onPushMsgArrived, this);
        Event.off(SYSTEM_EVENTS.SECOND_WEB_VIEW_CLOSE_ALL, this._closAllWebViews, this);
    }

    _subscribe() {
        if (this._model.isFeatureGameEnable()) {
            Event.on(SYSTEM_EVENTS.WEB_VIEW_NAVIGATE_GAME, this.openGame, this);
            Event.on(SYSTEM_EVENTS.SECOND_WEB_VIEW_CLOSE_ALL, this._closAllWebViews, this);
        }

        if (this._model.isFeatureCasheirEnable()) {
            Event.on(SYSTEM_EVENTS.WEB_VIEW_NAVIGATE_CASHIER, this._openCashierDirect, this);
        }

        if (this._model.isFeatureGameEnable() || this._model.isFeatureCasheirEnable()) {
            Event.on(SYSTEM_EVENTS.OAUTH_STATE_CHANGE, this._onOauthStateChange, this);
            Event.on(SYSTEM_EVENTS.DEEPLINK_RECEIVED, this._onPushMsgArrived, this);
        }


        Event.on(SYSTEM_EVENTS.SECOND_WEB_VIEW_NAVIGATE_SPORT, this._openSport, this);
        Event.on([SYSTEM_EVENTS.SCREEN_CHANGE_STATE, SYSTEM_EVENTS.SCREEN_RESIZE_CHANGED], this._onScreenState, this);
    }

    /**
     * set the Hybrid Display TimeOut
     * display the hybrid after timeout if the client didn't call it before.
     */
    setHybridDisplayTimeOut() {
        let timeOut = this._model.getDisplayHybridTimeout();
        if (timeOut >= 0) {
            this._displayHybridTimeout = DOM.setTimeout(() => {
                this._HybridService.displayHybrid();
            }, timeOut);
        }
    }

    setDepositWidgetSupported(){
        Event.on(SYSTEM_EVENTS.WEB_VIEW_NAVIGATE_DEPOSIT_WIDGET, this.openDepositWidget, this);
    }

    /**
     * clear the Hybrid Display TimeOut
     */
    clearHybridDisplayTimeOut() {
        if (this._displayHybridTimeout) {
            DOM.clearTimeout(this._displayHybridTimeout);
            this._displayHybridTimeout = null;
        }
    }

    /**
     * check if device support the SecondWebView
     * return bool
     */

    isNativeSupportSecondWebView() {
        return this._model.isFeatureGameEnable();
    }


    /**
     * check if device support the SafariCashier
     * return bool
     */

    isNativeSupportSafariCashier() {
        return this._model.isFeatureCasheirEnable();
    }

    /**
     * hybrid direct call
     * data example: {hybridcbfeaturefunc: "WebViewManagerFeature", webid: "1", action: "https://mirage.navigation-center.com/SharedNavigat…ackage%22%3A%2292%22%2C%22UserInfo%22%3A%22%22%7D"}
     */

    onHybridDirectCall(data) {
        let nId = Number(data[KEY_NAME.WEB_ID]);

        let webView = this._model.getWebViewById(nId);

        if (webView) {
            webView.onHybridDirectCall(data);
        }

        return webView;
    }

    openExternalLink(url) {
        this._HybridService.openExternalLink(url);
    }

    /**
     * get the url as an object
     * url: the url to convert to obj
     * bEncode: true = encode the url
     * return obj
     */
    _getObjUrl(url, bEncode) {
        if(true === bEncode){
            url = encodeURIComponent(url);
        }
        return {[WEB_VIEW_INFO.URL]: url};
    }

    openLinksAccomplished(webId, webType) {
        this._HybridService.openLinksAccomplished(webId, webType);
    }

    /**
     * open game - add the parameters for game
     * url: the url of game
     */
    openGame(url, gameTimeOut) {
        const obj = this._getObjUrl(url, true);

        this.fillFrameOffset(obj).then((objWithFrameOffset)=> {
            const filledObj = this._model.fillGameInfo(objWithFrameOffset, gameTimeOut);
            this._navigate(filledObj);
        });
    }

    /**
     * open Deposit Widget - add the parameters for game
     * url: empty
     */
    openDepositWidget(url) {

        let logger = this._getLogger();
        logger && logger.setEventType('hybrid_psp_redirect_handle_open').info();

        const obj = this._getObjUrl(url, false);

        this.fillFrameOffset(obj).then((objWithFrameOffset)=> {
            const filledObj = this._model.filDepositWidgetInfo(objWithFrameOffset);
            this._navigate(filledObj);
        });

        this._HybridService.closeNyxODRGame();
    }

    isDepositWidgetSupported(){
        return this._HybridService.isDepositWidgetSupported();
    }

    /**
     * get UrlScheme form Webview
     * return: the url scheme
     */
    _getUrlScheme() {
        return this._HybridService.getUrlScheme() + '://';
    }

    getUrlSchemeToOpen() {
        return this._HybridService.getUrlScheme() + '://';
    }

    /**
     * get Params For Casheir - build all the parameters to identify casheir
     * return: urlscheme + parameters for casheir
     */
    getParamsForCasheir() {

        let params = {
            [WEB_VIEW_INFO.TYPE]: 'WebViewManagerFeature',
            [WEB_VIEW_INFO.ACTION]: WEB_VIEW_INFO.CLOSE_CALLED_BY_WEB,
            [WEB_VIEW_INFO.ID]: WEB_VIEW_IDS.SAFARI_ID
        };

        let strJson = JSON.stringify(params)
        let uri = encodeURIComponent(strJson);

        let urlScheme = this.getUrlSchemeToOpen();
        let str = urlScheme + uri;

        return str;
    }

    /**
     * open Casheir - add the parameters for Casheir
     * url: the url of Casheir
     */
    openCasheir(url) {
        let obj = this._getObjUrl(url, false);

        obj = this._model.fillCashierInfo(obj);

        this._navigate(obj);
    }

    async _getHeaderHeight() {
        const headerRegulationDataElement = await ServiceFactory.create().integrationService().getHeaderRegulationDataElement()
        return headerRegulationDataElement.getBoundingClientRect().top + headerRegulationDataElement.offsetHeight;
    }

    async fillFrameOffset(obj) {
        const headerHeight = await this._getHeaderHeight();
        obj[KEY_NAME.HEADER_HEIGHT] = headerHeight * this._ndpToPx;
        return obj;
    }
    /**
     * open Sport - add the parameters for Sport
     * url: the url of Sport
     */
    _openSport(url) {
        let obj = this._getObjUrl(url, true);

        this.fillFrameOffset(obj).then((objWithFrameOffset)=> {
            const filledObj = this._model.fillSportInfo(objWithFrameOffset);
            this._navigate(filledObj);
        });
    }

    /**
     * open Cashier Direct with a url
     * url: the url of Casheir
     */
    _openCashierDirect(url) {

        let str = this.getParamsForCasheir();

        this.openCasheir(url + str);
    }

    /**
     * navigate to second webview
     * obj: the obj of game/Casheir
     * obj example: {url: "https://mirage.navigation-center.com/SharedNavigat…ackage%22%3A%2292%22%2C%22UserInfo%22%3A%22%22%7D", frameOffsetTopY: 0, type: 1, webid: 1, tapKeepAlive: "true", …}
     */
    _navigate(obj) {
        let webview = this._model.initWebView( obj[WEB_VIEW_INFO.TYPE], obj[WEB_VIEW_INFO.ID], this);

        if (null !== webview) {

            obj[WEB_VIEW_INFO.ID] = webview.getWebId();
            this._HybridService.navigateWebView(obj);
            webview.setCbFunctions(this._HybridService);

            this._showWithTimeOut(webview, obj);

            window.scrollTo(0, 0);
        } else if(WEB_VIEW_IDS.DEPOSIT_WIDGET_ID === obj[WEB_VIEW_INFO.ID]) {
            let logger = this._getLogger();
            logger && logger.setEventType('hybrid_psp_redirect_no_webview').error();
        }
    }

    /**
     * show the Loader and close at timeout
     * obj: the obj of game/Casheir
     * webview: the current webview
     */
    _showWithTimeOut(webview, obj) {

        const isDepositPSPRedirect = WEB_VIEW_IDS.DEPOSIT_WIDGET_ID === obj[WEB_VIEW_INFO.ID];

        let timeOut = obj[WEB_VIEW_INFO.DISPLAY_GAME_TIME_OUT] || 0;

        if(isDepositPSPRedirect){
            const logger = this._getLogger();
            logger && logger.setEventType('hybrid_psp_redirect_showWithTimeout_start')
                .addCustomData({
                    timeout: timeOut,
                    depositWindowData: obj
                })
                .info();
        }


        DOM.setTimeout(() => {
            obj[WEB_VIEW_INFO.TYPE] = webview.getType();
            let logger = this._getLogger();
            logger && logger.setEventType('hybrid_psp_redirect_showWithTimeout_end')
                .addCustomData({
                    timeout: timeOut,
                    depositWindowData: obj
                });

            try {
                this._show(obj);
                if(isDepositPSPRedirect) {
                    logger && logger.info();
                }
            } catch (err) {
                if(isDepositPSPRedirect) {
                    logger && logger.addCustomData({
                        errorDetails: err
                    }).error();
                }
                throw err;
            }

        }, timeOut);
    }


    /**
     * close WebView
     * webview: the webview to close
     */
    onclose(webview) {
        let obj = {};
        obj[WEB_VIEW_INFO.ID] = webview.getWebId();
        this._model.remove(webview);
        Event.fire(SYSTEM_EVENTS.SECOND_WEB_VIEW_CLOSE);
        this._HybridService.closeWebView(obj);
    }

    /**
     * on OauthStateChange - called when the status is changed
     * if we are logged out - we will close all the open WebVeiws
     */
    _onOauthStateChange() {
        if (false === ServiceFactory.create().oAuth2Service().isAuthorized()) {
            this._closAllWebViews();
        }
    }

    /**
     * on Push Msg Arrived - called when the push message arrive from hybrid
     */
    _onPushMsgArrived(){
        this._closAllWebViews();
    }

    _onOrientationStateInit(){

        let str = Device.isPortrait ? 'portrait' : '';
        this._onScreenState(str);
    }

    async _onScreenState(addOrientationState){
        let isPortrate = false;
        if(!Check.isNullOrUndefined(addOrientationState)) {
            isPortrate = 'portrait' === addOrientationState;
        } else {
            isPortrate = Device.isPortrait;
        }

        let allWebViews = this._model.getallOpenwebViews();

        for (let ii = 0; ii < allWebViews.length; ii++) {
            let webView = allWebViews[ii];

            let obj = {
                [WEB_VIEW_INFO.TYPE]: webView.getType(),
                [WEB_VIEW_INFO.ID]: webView.getWebId(),
                [WEB_VIEW_INFO.ORIENTATION]: isPortrate,
                [WEB_VIEW_INFO.HEADER_HEIGHT]: await this._getHeaderHeight()
            };

            this._HybridService.updateScreenSize(obj);
        }
    }

    _closAllWebViews(){
        let allWebViews = this._model.getallOpenwebViews();

        for (let ii = 0; ii < allWebViews.length; ii++) {
            let webView = allWebViews[ii];
            this.onclose(webView);
        }

        this._HybridService.closeNyxODRGame();
    }

    /**
     * show the WebView
     */
    _show(obj) {
        Event.fire(SYSTEM_EVENTS.SECOND_WEB_VIEW_OPEN);
        this._HybridService.showWebView(obj);


        this._onOrientationStateInit();
    }
}

export default WebViewManager;
